import type { Filters } from '@/domain';

export type PopularDestinationsProps = {
    updateAutocomplete: (selected, trackingInfo) => void;
    onFilterChanged: (filters: Filters) => void;
};

export const PopularDestinations = ({ updateAutocomplete, onFilterChanged }: PopularDestinationsProps) => {
    const lookupLocation = (name) => locations.find((location) => location.name === name);

    const handleClickFunc = (locationName: string) => () => {
        const location = lookupLocation(locationName);
        updateAutocomplete(location?.name, null);
        onFilterChanged({ ...location?.coordinates, country: location?.name, city: undefined });
        window.scroll(0, 0);
    };

    const locationElements = locations.map((location) => (
        <button
            className="relative rounded-8 w-full max-h-144 focus-ring"
            id={location.name}
            data-location-name={location.name}
            onClick={handleClickFunc(location.name)}
            data-testid={`PopularDestinations-${location.name}`}
            key={location.name}
            type="button"
            name="location"
            value={location.name}>
            <img className="rounded-8" src={location.image} alt="" />
            <span className="bg-gray-500 text-white font-bold text-14 rounded-tr-8 rounded-bl-8 p-6 inline-block absolute bottom-0 left-0">
                {location.name}
            </span>
        </button>
    ));

    return (
        <div className="hidden md:block my-32 px-16" data-testid="popularDestinations">
            <h3 className="text-16">Populære destinasjoner</h3>
            <div className="grid grid-cols-2 gap-8">{locationElements}</div>
        </div>
    );
};

const locations = [
    {
        name: 'Norge',
        image: require('./assets/norway.png').default?.src,
        coordinates: {
            lat_sw: '57.8097',
            lng_sw: '4.0649',
            lat_ne: '71.30780000000001',
            lng_ne: '31.3549998',
            query: '',
        },
    },
    {
        name: 'Spania',
        image: require('./assets/spain.png').default?.src,
        coordinates: {
            lat_sw: '33.499548',
            lng_sw: '-9.716923',
            lat_ne: '46.044901',
            lng_ne: '3.403853',
            query: '',
        },
    },
    {
        name: 'Frankrike',
        image: require('./assets/france.png').default?.src,
        coordinates: {
            lat_sw: '40.49799',
            lng_sw: '-5.042647',
            lat_ne: '51.801551',
            lng_ne: '8.07813',
            query: '',
        },
    },
    {
        name: 'Danmark',
        image: require('./assets/denmark.png').default?.src,
        coordinates: {
            lat_sw: '54.218724',
            lng_sw: '7.703142',
            lat_ne: '57.932606',
            lng_ne: '13.031833',
            query: '',
        },
    },
    {
        name: 'Sverige',
        image: require('./assets/sweden.png').default?.src,
        coordinates: {
            lat_sw: '55.0059799',
            lng_sw: '10.5798',
            lat_ne: '69.0599709',
            lng_ne: '24.1773102',
            query: '',
        },
    },
    {
        name: 'Kroatia',
        image: require('./assets/croatia.png').default?.src,
        coordinates: {
            lat_sw: '42.3385087',
            lng_sw: '13.3649',
            lat_ne: '46.5549857',
            lng_ne: '19.4480523',
            query: '',
        },
    },
    {
        name: 'USA',
        image: require('./assets/usa.png').default?.src,
        coordinates: {
            lat_sw: '2.460181',
            lng_sw: '-127.617187',
            lat_ne: '58.631217',
            lng_ne: '-71.367187',
            query: '',
        },
    },
    {
        name: 'Italia',
        image: require('./assets/italy.png').default?.src,
        coordinates: {
            lat_sw: '35.4897',
            lng_sw: '6.6267201',
            lat_ne: '47.092',
            lng_ne: '18.7975999',
            query: '',
        },
    },
    {
        name: 'Thailand',
        image: require('./assets/thailand.png').default?.src,
        coordinates: {
            lat_sw: '5.613038',
            lng_sw: '97.343396',
            lat_ne: '20.465143',
            lng_ne: '105.636812',
            query: '',
        },
    },
    {
        name: 'Hellas',
        image: require('./assets/greece.png').default?.src,
        coordinates: {
            lat_sw: '33.394675',
            lng_sw: '19.829526',
            lat_ne: '41.942383',
            lng_ne: '28.486011',
            query: '',
        },
    },
    {
        name: 'Tyrkia',
        image: require('./assets/turkey.png').default?.src,
        coordinates: {
            lat_sw: '35.808592',
            lng_sw: '25.5377',
            lat_ne: '42.3666999',
            lng_ne: '44.8178449',
            query: '',
        },
    },
    {
        name: 'Portugal',
        image: require('./assets/portugal.png').default?.src,
        coordinates: {
            lat_sw: '36.531357',
            lng_sw: '-11.307449',
            lat_ne: '42.43076',
            lng_ne: '-5.186391',
            query: '',
        },
    },
];
